export const getNextPlan = (planStacks, currentPlan, options = {}) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const nextPlanInterval = (_b = (_a = options.nextPlanInterval) !== null && _a !== void 0 ? _a : currentPlan.interval) !== null && _b !== void 0 ? _b : 'year';
    const nextPlanType = (_d = (_c = options.nextPlanType) !== null && _c !== void 0 ? _c : currentPlan.plan_type) !== null && _d !== void 0 ? _d : 'Free';
    const firstEligiblePlanTypeIndex = (_e = planStacks.findIndex((planStack) => planStack.planType === nextPlanType)) !== null && _e !== void 0 ? _e : 0;
    let nextPlan;
    for (let planTypeIndex = firstEligiblePlanTypeIndex; planTypeIndex < planStacks.length && !nextPlan; planTypeIndex++) {
        nextPlan = (_g = (_f = planStacks[planTypeIndex]) === null || _f === void 0 ? void 0 : _f.plans) === null || _g === void 0 ? void 0 : _g.find((plan) => plan.includedTasksPerMonth > currentPlan.included_tasks_per_month &&
            plan.interval === nextPlanInterval);
    }
    return nextPlan;
};
//# sourceMappingURL=getNextPlan.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
